module.exports = __webpack_public_path__ + "static/media/1-lira-tura.7c42669a.png";